import React from 'react';
import {dataYearState, CHANGE_YEAR_EVENT} from '../dataYearState';
import DataYearComp from '../../components/datayear/index';
//import {mapState, PADDING_SPACE_EVENT} from '../../state/map';
import { connect } from 'react-redux';

const stateEntryMap = {
  "2015/2016": "2016/2017. m.g.",
  "2016/2017": "2017/2018. m.g.",
  "2017/2018": "aktuālie dati",
}

function swap(json){
  var ret = {};
  for(var key in json){
    ret[json[key]] = key;
  }
  return ret;
}

class DataYear extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      years: dataYearState.years,
      selected: dataYearState.getActive(),
      leftOffset: 0,//mapState.getPadding()[3],
      active: true //layerState.isActive('quality_indicators')
    };
  }
  componentDidMount() {



    dataYearState.on(CHANGE_YEAR_EVENT, () => {

      this.setState({selected: dataYearState.getActive()});
    });

  /*  mapState.on(PADDING_SPACE_EVENT, () => {

      this.setState({leftOffset: mapState.getPadding()[3]});
    });
*/
  /*  layerState.on(CHANGE_EVENT, ()=>{

      if(layerState.isActive('quality_indicators') || layerState.isActive('school_types') || layerState.isActive('school_middle_count')) {
        var active = true;
      } else {
        var active = false;
      }

      this.setState({active: active});
    });*/
  }

  changeYear(event, index, value) {

    var stateEntryMapRev = swap(stateEntryMap);

    dataYearState.setActive(dataYearState.years.indexOf(stateEntryMapRev[index.key]));
  }

  render() {

    if(this.state.active === false) {

      return null;
    }

    var entries = [];
    for(var i = 0; i < this.state.years.length; i++)
    {
      entries.push(stateEntryMap[this.state.years[i]]);
    }

    return (
      <DataYearComp
          handleClick = {this.changeYear}
          entries = {entries}
          selected = {stateEntryMap[this.state.selected]}
          leftOffset = {this.props.padding[1]}
      />
    );
  }
}

const mapDispatchToPropsRes = (dispatch) => {

  return {
    clickItem: () => {
      
    }
  }
}

const mapStateToPropsRes = (state) => {

  return {
    padding: state.map.padding
  }
}

const MenuSection = connect(
  mapStateToPropsRes,
  mapDispatchToPropsRes
)(DataYear);

export default MenuSection;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/filters/dataYear/container.js